const createReactModalMount = (id: string) => {
    const main = document.getElementsByTagName('main').item(0) as HTMLElement;
    const mount = document.createElement('div') as HTMLDivElement;
    mount.id = id;
    main.appendChild(mount);
    return mount;
};

export default createReactModalMount;
